// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__fcWjT"};